import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { getApiEndpoint } from '../config/api';

const AdminLogin = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            // Adjust API URL as needed
            const response = await axios.post(getApiEndpoint('admin_login.php'), {
                email,
                password
            });

            if (response.data.success && response.data.user) {
                localStorage.setItem('adminUser', JSON.stringify(response.data.user));
                navigate('/admin/dashboard');
            } else {
                setError('Login failed: Invalid server response');
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Invalid email or password');
        }
    };

    const handleForgotPassword = () => {
        // Pass email to forgot password page
        navigate('/admin/forgot-password', { state: { email } });
    };

    return (
        <div className="admin-login-page">
            <div className="admin-login-card">
                <div className="admin-login-header">
                    <h2>Admin Login</h2>
                </div>
                <form className="mt-8 space-y-6" onSubmit={handleLogin}>
                    {error && <div className="admin-error">{error}</div>}
                    <div className="space-y-4">
                        <div className="admin-form-group">
                            <label htmlFor="email" className="sr-only">Email Address</label>
                            <input
                                id="email"
                                name="email"
                                type="email"
                                required
                                className="admin-input"
                                placeholder="Email Address"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>
                        <div className="admin-form-group">
                            <label htmlFor="password" className="sr-only">Password</label>
                            <input
                                id="password"
                                name="password"
                                type="password"
                                required
                                className="admin-input"
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </div>
                    </div>

                    <div>
                        <button
                            type="submit"
                            className="admin-btn"
                        >
                            Sign in
                        </button>
                    </div>

                    <div style={{ textAlign: 'center', marginTop: '1rem' }}>
                        <button
                            type="button"
                            onClick={handleForgotPassword}
                            style={{
                                background: 'none',
                                border: 'none',
                                color: '#6BAC9F',
                                textDecoration: 'none',
                                fontSize: '0.875rem',
                                cursor: 'pointer',
                                padding: 0
                            }}
                        >
                            Forgot Password?
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AdminLogin;
